import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetLogPaginetedParams, IGetLogPaginetedResponse } from './log.model';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor(private http: HttpClient) {}

  public GetLogPaginated(
    params: IGetLogPaginetedParams
  ): Observable<IGetLogPaginetedResponse> {
    const url = `${environment.baseURL}Log/GetLogPagineted`;
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;

    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) =>
          value !== '' &&
          value !== null &&
          value !== undefined &&
          !Number.isNaN(value) &&
          value !== 0
      )
    );

    return this.http.get<IGetLogPaginetedResponse>(url, {
      params: validParams
    });
  }
}
